"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledBottomContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const config_1 = require("../../assets/styles/config");
exports.StyledBottomContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;

  @media ${config_1.device.tablet} {
    flex-direction: row;
  }
`;
